import OfferEvent from '@core/models/offer/OfferEvent';
import { differenceInHours } from '@superbet-group/web.lib.utilities';

export const OfferQuickFilter = {
    Resulted: 'Resulted',
    Upcoming: 'Upcoming',
    NextHour: 'NextHour',
    Next3Hours: 'Next3Hours',
    Next6Hours: 'Next6Hours',
    Next12Hours: 'Next12Hours',
    Video: 'Video',
} as const;
export type OfferQuickFilter = typeof OfferQuickFilter[keyof typeof OfferQuickFilter];

export const LiveOfferQuickFilter = {
    All: 'All',
    Video: 'Video',
};
export type LiveOfferQuickFilter = typeof LiveOfferQuickFilter[keyof typeof LiveOfferQuickFilter];

const quickFilters: Record<OfferQuickFilter | LiveOfferQuickFilter, (event: OfferEvent) => boolean> = {
    Resulted: (event: OfferEvent) => {
        return event.isFinished();
    },
    Upcoming: (event: OfferEvent) => {
        return !event.isFinished();
    },
    NextHour: (event: OfferEvent) => {
        return differenceInHours(event.date, new Date()) < 1 && !event.isFinished();
    },
    Next3Hours: (event: OfferEvent) => {
        return differenceInHours(event.date, new Date()) < 3 && !event.isFinished();
    },
    Next6Hours: (event: OfferEvent) => {
        return differenceInHours(event.date, new Date()) < 6 && !event.isFinished();
    },
    Next12Hours: (event: OfferEvent) => {
        return differenceInHours(event.date, new Date()) < 12 && !event.isFinished();
    },
    Video: (event: OfferEvent) => {
        return event.hasStream && !event.isFinished();
    },
    All: () => true,
};

type OfferFilterFunction = (event: OfferEvent) => boolean;

export function applyQuickFilter(quickFilter: OfferQuickFilter | OfferFilterFunction, events: OfferEvent[]): OfferEvent[] {
    if (typeof quickFilter === 'function') {
        return events.filter((event) => quickFilter(event));
    }
    return events.filter((event) => quickFilters[quickFilter](event));
}

const OfferQuickFilterTranslationKeys: Record<OfferQuickFilter | LiveOfferQuickFilter, string> = {
    Resulted: 'sportOffer.quickFilter.resulted',
    Upcoming: 'sportOffer.quickFilter.upcoming',
    NextHour: 'sportOffer.quickFilter.nextHour',
    Next3Hours: 'sportOffer.quickFilter.next3hours',
    Next6Hours: 'sportOffer.quickFilter.next6hours',
    Next12Hours: 'sportOffer.quickFilter.next12hours',
    Video: 'sportOffer.quickFilter.video',
    All: 'all',
};

export function getQuickFilterTranslationKey(quickFilter: OfferQuickFilter | LiveOfferQuickFilter): string {
    return OfferQuickFilterTranslationKeys[quickFilter];
}

export const InPlaySortingFilter = {
    Default: 'Default',
    StartTimeAscending: 'StartTimeAscending',
    StartTimeDescending: 'StartTimeDescending',
} as const;
export type InPlaySortingFilter = typeof InPlaySortingFilter[keyof typeof InPlaySortingFilter];

export const SortingFilterTranslationKeys: Record<InPlaySortingFilter, string> = {
    Default: 'offer.live_events_sorting.default',
    StartTimeAscending: 'offer.live_events_sorting.start_time_descending',
    StartTimeDescending: 'offer.live_events_sorting.start_time_ascending',
};

export function getInPlaySortingFilterTranslationKey(sortingFilter: InPlaySortingFilter): string {
    return SortingFilterTranslationKeys[sortingFilter];
}
